import React from 'react';
import {Menu, Transition} from "@headlessui/react";
import {EllipsisVerticalIcon, LockClosedIcon} from "@heroicons/react/20/solid";
import Tooltip from "../../tooltip";

export default function NavResponsiveMenu({allTabs, onTabChange, lastVisibleTab, translate}) {

    const menuItems = allTabs.filter((it, i) => i > lastVisibleTab && !it.current).map(it => { // current item is no longer rendering
        const isDisabled = !!it.disabled || it.hasPerm === false;
        return (
            <Menu.Item key={it.name}>
                {({active}) => (
                    <Tooltip
                        disabled={!isDisabled}
                        placement={"left"}
                        content={"You don't have permission to perform this action."}
                    >
                        <span
                            onClick={() => !isDisabled && onTabChange(it.resource)}
                            className={`py-2 px-4 flex items-center hover:bg-tm-gray-100 hover:text-tm-gray-900 ${isDisabled ? 'opacity-50 cursor-default' : `cursor-pointer ${active ? 'bg-tm-gray-100 text-tm-gray-900' : it.current ? 'text-primary' : 'text-tm-gray-700'}`} ${!!it.current && 'font-bold'}`}
                        >
                            {translate("tab." + it.name)}

                            {it.hasPerm === false && (
                                <LockClosedIcon className="w-4 h-4 ml-1 -mr-1 text-red-500 opacity-50"/>
                            )}
                        </span>
                    </Tooltip>
                )}
            </Menu.Item>
        )
    })

    return (
        <Menu>
            {({open}) => (
                <React.Fragment>
                    <Menu.Button
                        className="absolute text-inverse w-8 h-8 p-0 flex justify-center items-center right-0 top-1 hover:bg-tm-gray-100 rounded-full focus:outline-hidden focus:ring-2 ring-primary-tint cursor-pointer">
                        <EllipsisVerticalIcon className="w-5 h-5 text-primary"/>
                    </Menu.Button>

                    <Transition
                        show={open}
                    >
                        <Menu.Items
                            className="z-40 absolute right-0 top-12 w-56 py-2 origin-top-right bg-inverse rounded-md shadow-lg ring-1 ring-black/10 focus:outline-hidden border border-tm-gray-200"
                        >
                            {menuItems}
                            {/*<div*/}
                            {/*    className="absolute w-2 h-2 -top-1 right-3 border-l border-t transform rotate-45 border-solid border-tm-gray-200 bg-inverse -z-1"/>*/}
                        </Menu.Items>
                    </Transition>
                </React.Fragment>
            )}
        </Menu>
    )
}
